import {
  ORIENTATION_LEFT_TO_RIGHT,
  ORIENTATION_TOP_TO_BOTTOM,
  ORIENTATION_RIGHT_TO_LEFT,
  ORIENTATION_BOTTOM_TO_TOP,
} from '@Components/D3Tree/constants';

export function isHorizontal(orientation) {
  return orientation === ORIENTATION_LEFT_TO_RIGHT
    || orientation === ORIENTATION_RIGHT_TO_LEFT;
}

export function transformToOrientation({ x, y }, orientation) {
  switch(orientation) {
    case ORIENTATION_LEFT_TO_RIGHT: {
      return { x: y, y: -x };
    }
    case ORIENTATION_TOP_TO_BOTTOM: {
      return { x, y };
    }
    case ORIENTATION_RIGHT_TO_LEFT: {
      return { x: -y, y: x };
    }
    case ORIENTATION_BOTTOM_TO_TOP: {
      return { x: -x, y: -y };
    }
    default: {
      return { x, y }
    }
  }
}
